import React from 'react';
import Toggle from 'react-toggle';
import Input from 'components/forms/Input';
import Tooltip from 'components/Tooltip';
import { DeleteOutlined } from '@ant-design/icons';
import InputLabel from '../common/InputLabel';
import FormRow from './FormRow';
import PercentageSelect from './PercentageSelect';
import OutputLabel from '../common/OutputLabel';

const WideInputWithSelectRow = ({
    id,
    editableTitle = false,
    onChangeTitle = null,
    grossValue,
    onChangeGrossValue,
    profitMargin,
    onChangeMargin,
    netProfit,
    removeItem = null,
    title,
    showWashToggle = false,
    onToggleWashChange = null,
    applyWash = false,
    showCommissionToggle = false,
    onToggleCommissionChange = null,
    applyCommission = false,
    showDeleteIcon = false,
    currency,
    selectStyles,
}) => {
    const outputString = `${currency}${netProfit.toFixed(2)}`;
    return (
        <FormRow style={{ display: 'flex', alignItems: 'center' }}>
            {editableTitle ? (
                <Input
                    placeholder="Other"
                    style={{ width: '20%' }}
                    onChange={(event) => onChangeTitle(id, event.target.value)}
                    value={title}
                    className="grpDisp-form-number-new"
                />
            ) : (
                <InputLabel style={{ width: '20%' }} text={title} />
            )}
            <Input
                type="number"
                value={grossValue}
                onChange={(event) => onChangeGrossValue(id, event.target.value)}
                className="grpDisp-form-number"
                addonBefore={currency}
            />
            <PercentageSelect
                id={id}
                selectedOption={profitMargin}
                handleChange={onChangeMargin}
                selectStyles={selectStyles}
            />
            <div className="grpDisp-form-toggle-block">
                {showWashToggle && (
                    <Toggle
                        onChange={(event) => onToggleWashChange(id, event.target.checked)}
                        checked={applyWash}
                        className="grpDisp-form-toggle-in-table"
                    />
                )}
                {showCommissionToggle && (
                    <Toggle
                        onChange={(event) => onToggleCommissionChange(id, event.target.checked)}
                        checked={applyCommission}
                        className="grpDisp-form-toggle-in-table"
                    />
                )}
            </div>

            <OutputLabel text={outputString} className="grpDisp-form-output-number" style={{ width: '20%' }} />
            {showDeleteIcon && (
                <Tooltip title="Warning - this will remove this item" placement="right">
                    <DeleteOutlined onClick={() => removeItem(id)} />
                </Tooltip>
            )}
        </FormRow>
    );
};

export default WideInputWithSelectRow;
